import React from 'react';
import styled from 'styled-components';
import { ColContainer } from '.';

const Wrapper = styled(ColContainer)`
  margin-top: 20px;
  width: 100%;
  padding: 0 20px;
`

const Video = styled(ColContainer)`
  justify-content: center;
  width: calc(100vw - 40px);
  max-width: 100%;
  height: calc((min(100vw, 600px) - 40px) * 9 / 16);
  max-height: calc(100vh - 480px);
  border-radius: 8px;
  overflow: hidden;
`

const Title = styled.div`
  padding: 20px 8px 4px;
  font-weight: 600;
  font-size: 20px;
`

const Name = styled.div`
  font-size: 16px;
`

function Keynote() {
  return (
    <Wrapper>
      <Video>
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/hprHZX0tk0U" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
      </Video>

      <Title>
        오프닝 키노트
      </Title>

      <Name>
        🎙 한도협
      </Name>
    </Wrapper>
  )
}

export default Keynote
